import { Component, OnDestroy, OnInit } from '@angular/core';
import { ThemeService } from '../../../@prep/services/theme.service';
import { map } from 'rxjs/operators';

import { LanguageSelectorModel } from 'src/@prep/shared/language-selector/model/language-selector.model';
import { LanguageSelectorService } from 'src/@prep/shared/language-selector/service/language-selector.service';
import { FooterTextDataEN } from './footer-multi-lang/en-US';
import { FooterTextDataES } from './footer-multi-lang/es-EU';
import { FooterTextDataIT } from './footer-multi-lang/it-IT';

@Component({
  selector: 'prep-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit, OnDestroy {

  visible$ = this.themeService.config$.pipe(map(config => config.footerVisible));


  selectedLang: LanguageSelectorModel = this.languageSelectorService.getCurrentLanguage();
  LangTextData: any;

  constructor(private themeService: ThemeService,
    private languageSelectorService: LanguageSelectorService,
  ) {
    this.languageSelectorService.language$.subscribe(lang => {
      this.selectedLang = lang;
      console.log('🌍 Language changed:', lang, lang.code, this.selectedLang.code);
      switch (this.selectedLang.code) {
        case 'en': {
          this.LangTextData = FooterTextDataEN;
          console.log('🌍 English Language:', this.LangTextData);
          break;
        }
        case 'es': {
          this.LangTextData = FooterTextDataES;
          console.log('🌍 English Language:', this.LangTextData);
          break;
        }
        case 'it': {
          this.LangTextData = FooterTextDataIT;
          console.log('🌍 English Language:', this.LangTextData);
          break;
        }
        default: {
          this.LangTextData = FooterTextDataEN;
          console.log('🌍 Default Language:', this.LangTextData);
          break;
        }
      }
    });
  }

  ngOnInit() {
  }

  hide() {
    this.themeService.setFooterVisible(false);
  }

  ngOnDestroy(): void { }
}
